import { useModalBehavior } from "@/hooks/behaviors";
import type { SrmSupplierAdmissionApplicationPage } from "@/types/apis";
import type { FormInstance } from "antd";
import { useCallback, useState } from "react";

export const useAdmissionApplicationSelect = (form: FormInstance) => {
  const { open, openModal, closeModal } = useModalBehavior();

  // 准入申请详情映射 {字段名: 准入申请详情}，用于回显名称
  const [admissionApplicationsMap, setAdmissionApplicationsMap] = useState<
    Record<string, SrmSupplierAdmissionApplicationPage>
  >({});

  // 添加选中的准入申请
  const addAdmissionApplication = useCallback(
    (fieldName: string, application: SrmSupplierAdmissionApplicationPage) => {
      form.setFieldValue(fieldName, application.id);
      setAdmissionApplicationsMap((prev) => ({
        ...prev,
        [fieldName]: application,
      }));
    },
    [form],
  );

  // 移除准入申请
  const removeAdmissionApplication = useCallback(
    (fieldName: string) => {
      form.setFieldValue(fieldName, "");
      setAdmissionApplicationsMap((prev) => {
        const newMap = { ...prev };
        delete newMap[fieldName];
        return newMap;
      });
    },
    [form],
  );

  // 获取指定字段的准入申请详情
  const getAdmissionApplication = useCallback(
    (fieldName: string) => admissionApplicationsMap[fieldName],
    [admissionApplicationsMap],
  );

  return {
    admissionApplicationOpen: open,
    openAdmissionApplicationModal: openModal,
    closeAdmissionApplicationModal: closeModal,
    addAdmissionApplication,
    removeAdmissionApplication,
    getAdmissionApplication,
  };
};
